import { ThemeProvider, White } from "@bonusx-global/bx-design-system";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { ErrorBoundary } from "react-error-boundary";

import ErrorBoundaryFallback from "../../../../components/blocks/ErrorBoundaryFallback/ErrorBoundaryFallback";
import { SurveyGuidedModeDrawer } from "./survey-guided-mode-drawer";

export interface SurveyWrapperProps {
  onError?: (error: Error) => void;
  children: React.ReactNode;
  backgroundColor?: string;
}

export function SurveyWrapper({ children, backgroundColor = White.main, onError }: Readonly<SurveyWrapperProps>) {
  return (
    <ThemeProvider>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            backgroundColor,
          },
        }}
      />
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} onError={onError}>
        {children}
        <SurveyGuidedModeDrawer />
      </ErrorBoundary>
    </ThemeProvider>
  );
}
